import { useEffect, useState } from 'react';
import { useRouteMatch } from "react-router-dom";
import { API } from 'aws-amplify';
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { getCompanyMetadata, getProductsForMetadata } from '../../graphql/queries';
import { Helmet } from 'react-helmet-async';
import {GET_COMPANIES_URL, GET_PRODUTCS_URL } from '../../utils/Constants';

export function CompanyStoreMetadata() {

	let { params } = useRouteMatch('/company-store/:companyName/:companyid');
	const [companyMetadata, setCompanyMetadata] = useState([]);
	const [featuredProducts, setFeaturedProducts] = useState([]);

	useEffect(() => {
		searchMetadata(params);
	}, []);

	const searchMetadata = async({companyid}) => {
		const products = [];
		const input = {
			id: companyid
		};

		try {

			/*const companyResult  = await API.graphql({
                query: getCompanyMetadata,
                variables: input,
                authMode: GRAPHQL_AUTH_MODE.AWS_IAM
              });*/
			const response = await fetch(GET_COMPANIES_URL);
			const companyResult  = await response.json();

			if (companyResult) {
				const productsResponse = await fetch(GET_PRODUTCS_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' } });
            	const allProducts = await productsResponse.json();		
				setFeaturedProducts(allProducts.filter(p => p.company_id === companyid));		

				/*let productsInput = { 
					filter: { and: {
								owner: {eq: companyResult.data.getCompany.owner},  
								status: {eq: 1}
							}
						}
					};

				do {
					let productsResults = await API.graphql({
						query: getProductsForMetadata,
						variables: productsInput,
						authMode: GRAPHQL_AUTH_MODE.AWS_IAM
					});

					products.push(...productsResults.data.listProducts.items);
					productsInput.nextToken = productsResults.data.listProducts.nextToken;
				} 
				while (productsInput.nextToken);
				*/
			}
			const companyData = companyResult.filter(c => c.id === companyid);
			console.log('companyData', companyData);
			setCompanyMetadata(companyData[0] || {});
			

		} catch (e){
			console.error(e);
		}
	};

    const getMetaDescription = () => {
        if (!companyMetadata) return '';
        //NOMBRE_EMPRESA, supplier of SUBCATEGORY in Mexico, USA & Canada. We manufacture PRODUCT 1, PRODUCT 2 and PRODUCT 3.
        return `${companyMetadata.name}, supplier of ${getSubcategory()} supplier in Mexico, USA & Canada. We manufacture ${featuredProducts?.map(p => p.name).join(', ')}.`;
    };

    const getSubcategory = () => {
    	const category = companyMetadata.featured_category || '';

    	return category.split('|')[1] || '';
    }

    const getImage = () => {
        if (!companyMetadata) return '';
        if (!companyMetadata.cover_picture) return '';
        return 'https://images.bainub.com/public/' + encodeURIComponent(companyMetadata.cover_picture.key);
    }

	return (
		<Helmet>
            <meta name="description" content={getMetaDescription()} />
            <meta property="og:title" content={companyMetadata ? companyMetadata.name: ''} />
            <meta property="og:description" content={getMetaDescription()} />  
            <meta property="og:image" content={getImage()} />
            <meta property="og:url" content={window.location.href} />
        
            <meta name="keywords" content={(companyMetadata ? `${companyMetadata.name}, ${getSubcategory()}, ${featuredProducts?.map(p => p.name).join(', ')}` : '') + 'supplier in mexico, usa supplier, oem, manufacturer'} />
                
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={companyMetadata ? companyMetadata.name : ''} />
            <meta name="twitter:description" content={getMetaDescription()} />
            <meta name="twitter:image" content={getImage()} />
        </Helmet>
	);
}